var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4 pr-4"},[_c('div',{staticClass:"association-logo",style:({'background-image':'url('+(_vm.logo)+')'})})])}
var staticRenderFns = []

export { render, staticRenderFns }